import { render, staticRenderFns } from "./SoundIndex.vue?vue&type=template&id=0ec8f87c&scoped=true"
import script from "./SoundIndex.vue?vue&type=script&lang=js"
export * from "./SoundIndex.vue?vue&type=script&lang=js"
import style0 from "./SoundIndex.vue?vue&type=style&index=0&id=0ec8f87c&prod&scoped=true&lang=css"
import style1 from "./SoundIndex.vue?vue&type=style&index=1&id=0ec8f87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8f87c",
  null
  
)

export default component.exports